export interface TermsTemplate {
  key: string;
  label: string;
  text: string;
}

// Dummy templates - replace with real ones later.
export const TERMS_AND_CONDITIONS_TEMPLATES: TermsTemplate[] = [
  {
    key: 'standard-warranty',
    label: 'Standard 12-Month Warranty',
    text: 'All goods and services are covered by a 12-month warranty from the date of delivery against defects in materials and workmanship. Defective items will be repaired or replaced at the supplier\'s cost.',
  },
  {
    key: 'extended-warranty',
    label: 'Extended 24-Month Warranty',
    text: 'All goods are covered by a 24-month warranty from the date of delivery. The supplier will respond to warranty claims within 48 hours and replace defective items within 14 days.',
  },
  {
    key: 'sla-standard',
    label: 'Standard SLA (Response 24h)',
    text: 'The supplier shall respond to service requests within 24 hours and resolve critical issues within 5 working days. Repeated failure to meet these targets may result in penalties of 1% of the order value per week of delay.',
  },
  {
    key: 'delivery-penalty',
    label: 'Late Delivery Penalty',
    text: 'Delivery must be completed within the agreed lead time. Late delivery attracts a penalty of 0.5% of the order value per day of delay, capped at 10% of the order value.',
  },
  {
    key: 'payment-conditional',
    label: 'Final Payment Subject to Acceptance',
    text: 'The final payment is released only after the goods or services have been delivered, inspected and accepted in writing by the buyer.',
  },
  {
    key: 'custom',
    label: 'Custom (write your own)',
    text: '',
  },
];
